<ng-container [ngSwitch]="productType">
  <app-application-page-orv *ngSwitchCase="'orv'"></app-application-page-orv>
  <app-application-page-gg *ngSwitchCase="'gg'"></app-application-page-gg>
</ng-container>
